import React from 'react';
import { Card } from '@themesberg/react-bootstrap';

function ShiftWidget({title, Noshift , time}) {
  return (
    <Card className="text-center m-4">
      <Card.Header>{title}</Card.Header>      
      <Card.Body>
        <Card.Title className='fs-1'>{Noshift}</Card.Title>
      </Card.Body>
      <Card.Footer className="text-muted">Tiempo estimado <span className='text-primary'>{time} horas</span></Card.Footer>
    </Card>
  );
}

export default ShiftWidget;
